var _defs, _tspan, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTs22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "55.139942mm",
    height: "132.29166mm",
    viewBox: "0 0 55.139942 132.29166",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-164.70833)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g120",
    transform: "matrix(1.3632642,0,0,1.3632642,0,-107.88948)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.414724,64.42769)",
    id: "text108",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    "aria-label": "\\uE082"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path113",
    d: "m 53.380657,168.72521 c 0,-1.20265 -0.481062,-1.32292 -1.202655,-1.32292 -0.721593,0 -1.082389,0.3608 -1.202655,0.96212 0,0 -0.120265,0.12027 -0.120265,0.24054 -0.962124,2.28504 -1.683717,4.08902 -3.72823,4.08902 -0.481062,0 -0.962124,0 -1.683717,-0.24053 -1.202654,-0.48106 -1.924247,-0.60133 -2.886371,-1.08239 -1.924247,-0.72159 -6.37407,-2.28504 -10.34283,-2.28504 -1.322921,0 -2.525575,0.24053 -3.607965,0.60132 2.164779,-3.48769 10.342831,-6.37407 12.387344,-6.97539 1.443186,-0.3608 5.532212,-1.08239 8.659114,-3.72823 2.405309,-1.80398 4.209292,-4.57009 4.209292,-8.89965 0,-4.44982 -1.924248,-7.69699 -4.449823,-9.86177 -4.930884,-4.08902 -12.387344,-4.69035 -14.552122,-4.69035 -2.525575,0 -5.893008,0.12027 -8.298318,0.60133 -3.367433,0.72159 -6.734866,2.7661 -9.140176,5.41194 -1.563451,2.04452 -2.64584,4.44983 -2.64584,7.09567 0,1.32292 0.240531,2.64584 0.841858,4.08902 1.443186,3.00664 4.449823,5.29168 7.937522,5.29168 5.893008,0 6.734866,-6.01327 6.734866,-8.41858 0,-5.77274 -6.614601,-6.13354 -6.614601,-8.05779 0.120265,-1.32292 1.924248,-3.60796 7.576725,-3.60796 8.538848,0 8.659114,6.37407 8.659114,9.26044 0,3.60797 -1.202655,6.9754 -3.247168,9.7415 -3.487699,4.69036 -6.253805,6.9754 -10.944158,9.86177 -5.291681,3.36744 -9.01991,8.05779 -10.703627,14.07106 0,0.24053 0,0.48107 0,0.60133 0,1.08239 0.601327,2.28504 1.683717,3.00664 0.240531,0.24053 0.601327,0.24053 0.721592,0.24053 2.164779,0 3.367434,-5.89301 9.019911,-5.89301 3.848495,0 5.291681,5.17142 13.830529,5.17142 4.089026,0 11.545486,-0.3608 13.108937,-15.27372 z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.414724,64.42769)",
    id: "text39",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    "aria-label": "\\uE082"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "m 52.019941,216.577 c 0,-1.20265 -0.481062,-1.32292 -1.202655,-1.32292 -0.721593,0 -1.082389,0.3608 -1.202655,0.96213 0,0 -0.120265,0.12026 -0.120265,0.24053 -0.962124,2.28504 -1.683717,4.08902 -3.72823,4.08902 -0.481062,0 -0.962124,0 -1.683716,-0.24053 -1.202655,-0.48106 -1.924248,-0.60133 -2.886372,-1.08239 -1.924247,-0.72159 -6.37407,-2.28504 -10.34283,-2.28504 -1.322921,0 -2.525575,0.24053 -3.607965,0.60133 2.164779,-3.4877 10.342831,-6.37407 12.387344,-6.9754 1.443186,-0.3608 5.532212,-1.08239 8.659114,-3.72823 2.40531,-1.80398 4.209292,-4.57009 4.209292,-8.89965 0,-4.44982 -1.924248,-7.69699 -4.449823,-9.86176 -4.930884,-4.08903 -12.387343,-4.69036 -14.552122,-4.69036 -2.525575,0 -5.893008,0.12027 -8.298318,0.60133 -3.367433,0.72159 -6.734866,2.76611 -9.140175,5.41195 -1.563452,2.04451 -2.645841,4.44982 -2.645841,7.09566 0,1.32292 0.240531,2.64584 0.841858,4.08902 1.443186,3.00664 4.449823,5.29169 7.937522,5.29169 5.893008,0 6.734866,-6.01328 6.734866,-8.41859 0,-5.77274 -6.614601,-6.13354 -6.614601,-8.05778 0.120266,-1.32292 1.924248,-3.60797 7.576725,-3.60797 8.538848,0 8.659114,6.37407 8.659114,9.26044 0,3.60797 -1.202655,6.9754 -3.247168,9.74151 -3.487699,4.69035 -6.253804,6.97539 -10.944158,9.86176 -5.291681,3.36744 -9.01991,8.05779 -10.703627,14.07106 0,0.24054 0,0.48107 0,0.60133 0,1.08239 0.601327,2.28505 1.683717,3.00664 0.240531,0.24053 0.601327,0.24053 0.721593,0.24053 2.164778,0 3.367433,-5.89301 9.01991,-5.89301 3.848495,0 5.291681,5.17142 13.830529,5.17142 4.089026,0 11.545486,-0.3608 13.108937,-15.27372 z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs22);
export default __webpack_public_path__ + "static/media/ts-2-2.c53e563ae608e9eaead99541ea5ad16b.svg";
export { ForwardRef as ReactComponent };